import React from 'react';
import { SelectButtonContainer, SelectButton as SelectButton$1 } from './SelectButton.styles.js';
import { constants } from '@citygross/design-tokens';

var SelectButton = function SelectButton(_a) {
  var items = _a.items,
      selected = _a.selected,
      _b = _a.width,
      width = _b === void 0 ? constants.selectButtonWidth : _b;
  return React.createElement(SelectButtonContainer, {
    length: items === null || items === void 0 ? void 0 : items.length,
    selected: selected,
    width: width
  }, items === null || items === void 0 ? void 0 : items.map(function (_a, i) {
    var label = _a.label,
        _onClick = _a.onClick;
    return React.createElement(SelectButton$1, {
      key: label,
      onClick: function onClick() {
        _onClick && _onClick();
      },
      selected: selected === i,
      width: width
    }, label);
  }));
};

export { SelectButton };